import React, { Component } from 'react'
import { withStyles } from '@mui/styles';

import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  DialogContentText,
  TextField,
  Button
} from '@mui/material'


const styles = theme => ({
  root: {
    marginTop: theme.spacing.unit * 3,
    textAlign: "center",

  }
});

const textFieldStyle = {
  background: 'white',
  borderRadius: 5,
  border: 0,
  height: 39,
  width: 200,
  padding: '0 30px',
  marginTop: 20,
  marginBottom: 0
  
}


class ForceUpdate extends Component {
  state = {
    password: '',
    confirmpassword: '',
    openAlert: false,
    alertMessage: ''
  }

  handleChange = prop => event => {
    this.setState({ [prop]: event.target.value })
  }

  kcPassword = event => {
    if (event.keyCode === 13 || event.which === 13)
      this.handleLoginClick()
  }

  handleMouseDownPassword = event => {
    event.preventDefault()
  }

  handleLoginClick = () => {
    var strongRegex = new RegExp("^(?=.{8,})(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*\\W).*$", "g")
    if (this.state.password !== this.state.confirmpassword) {
      this.setState({
        openAlert: true,
        alertMessage: "Passwords don't match. Please, try again."
      });
    } else if (false === strongRegex.test(this.state.password)) {
      this.setState({
        openAlert: true,
        alertMessage: "Password must have a minimun of 8 characters, must contain capital letter, number and special character."
      });
    } else {
      this.props.changepass(this.state.password)
    }    
  }

   handleAlertClose = () => {
     this.setState({
       openAlert: false
     });
   };



  render() {
    return (
      <div>
      <Dialog
        open
        fullScreen = {
          false
        }
        maxWidth = 'xs'
        >
        < DialogTitle style={
          {textAlign: "center"}}>
          <img src = "images/amplia_title_nobackground.png" height = "40" alt="AMPLIA logo" />
        </DialogTitle>
        <DialogContent
                  style = {
            {
              textAlign: "center",
              marginTop: 20,
            }} >
          < DialogContentText >
            Create New Password
          </DialogContentText>
           < DialogContentText variant='caption'>
            Minimun 8 characters, must contain capital letter, number and special character
          </DialogContentText>
 
          <TextField
            id="password"
            placeholder = "Password"
            type="password"
            onChange={this.handleChange('password')}
            // onKeyPress={this.kcPassword}
            fullWidth
            inputProps={{ disableUnderline: true, height: 30, sx: { color: 'black', p:1 }}}
            style={ textFieldStyle}
          />
          <TextField
            id="confirmpassword"
            placeholder = "Confirm pass"
            type="password"
            onChange={this.handleChange('confirmpassword')}
            onKeyPress={this.kcPassword}
            fullWidth
            inputProps={{ disableUnderline: true, height: 30, sx: { color: 'black', p:1 }}}
            style={ textFieldStyle}
          />
        </DialogContent>
                <DialogActions>
          < Button
            onClick={this.handleLoginClick}
            style={
            {
              background: '#47ED3E',
              fontWeight: 'bold',
              borderRadius: 5,
              border: 0,
              color: '#55565A',
              height: 40,
              padding: '0 30px',
              width: 200,
              marginBottom: 20,
              marginLeft: 'auto',
              marginRight: 'auto'
            }
          } >
            SUBMIT
          </Button>
        </DialogActions> 
      </Dialog>
      <Dialog
          open = {
            this.state.openAlert
          }
          onClose={this.handleAlertClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              {this.state.alertMessage}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleAlertClose} style={{ color: 'white' }} autoFocus>
              OK
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    )
  }
}

export default withStyles(styles)(ForceUpdate)